import React, { useEffect, useState } from 'react';
// import VisibilityIcon from '@mui/icons-material/Visibility';
import Button from '@mui/material/Button';
import AddCameraButton from './components/AddCameraButton';
import './RightBar.css';
import {
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Typography,
  // Tooltip,
  Snackbar,
  Alert,
  Drawer,
  // MenuItem,
  // Menu,
  Popover
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
// import { getAllCameras, deleteCamera } from '../../../../api/FM/videoPageApis';
// import MenuIcon from '@mui/icons-material/Menu';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import { IoCloseCircleOutline } from 'react-icons/io5';
import { CloseOutlined } from '@mui/icons-material';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
// import Switch from '@mui/material/Switch';
// import NotificationsIcon from '@mui/icons-material/Notifications';
import CircleNotificationsRoundedIcon from '@mui/icons-material/CircleNotificationsRounded';
// import CircleIcon from '@mui/icons-material/Circle';
import { Edit as EditIcon, Delete as DeleteIcon } from 'lucide-react';

const CameraCard = ({ camera }) => {
  const dispatch = useDispatch();
  // const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  // const [isDeleting, setIsDeleting] = useState(false);
  // const videoPlaying = useSelector((state) => state.cameraReducer.videoPlaying);
  const selectedCamera = useSelector((state) => state.cameraReducer.cameraData);
  const isSelected = selectedCamera && selectedCamera._id === camera._id;
  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  // const [anchorEl, setAnchorEl] = useState(null);
  // const open = Boolean(anchorEl);

  // const handleMenuClick = (event) => {
  //   event.stopPropagation();
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    setIsEditing(true);
  };

  // Function to handle camera delete
  const handleDelete = (e) => {
    e.stopPropagation();
    setShowDeleteConfirm(true);
  };

  // Function to confirm camera deletion
  const confirmDelete = () => {
    console.log('Deleting camera:', camera._id);
    setShowDeleteConfirm(false);
  };

  // Function to cancel deletion
  const cancelDelete = () => {
    setShowDeleteConfirm(false);
  };

  // const handleDeleteCamera = async () => {
  //   try {
  //     setIsDeleting(true);
  //     await deleteCamera(camera._id);
  //     dispatch({ type: 'CAMERA_ADDED' }); // Reuse this action to trigger refetch
  //     dispatch({ type: 'VIDEO_PLAYING', videoPlaying: false }); // Reset video playing state
  //     setSnackbar({
  //       open: true,
  //       message: 'Camera deleted successfully',
  //       severity: 'success'
  //     });
  //   } catch (error) {
  //     setSnackbar({
  //       open: true,
  //       message: error.message || 'Failed to delete camera',
  //       severity: 'error'
  //     });
  //   } finally {
  //     setIsDeleting(false);
  //     setIsDeleteModalOpen(false);
  //   }
  // };

  // const handleDeleteClick = (e) => {
  //   e.stopPropagation();
  //   if (videoPlaying) {
  //     dispatch({ type: 'VIDEO_PLAYING', videoPlaying: false }); // Reset video playing state before opening dialog
  //   }
  //   setIsDeleteModalOpen(true);
  // };

  // const handleToggleCamera = async (cameraId) => {
  //   try {
  //     // Toggle active state (Example: You can update this logic based on API structure)
  //     await updateCameraStatus(cameraId, !camera.active);
  //     dispatch({ type: 'CAMERA_ADDED' }); // Refresh camera list
  //   } catch (error) {
  //     console.error('Error toggling camera:', error);
  //   }
  // };

  const handleCardClick = () => {
    dispatch({
      type: 'SET_CAMERA',
      cameraData: camera
    });

    dispatch({
      type: 'VIDEO_PLAYING',
      videoPlaying: true
    });

    console.log(`Playing video from camera: ${camera.name}, URL: ${camera.videoUrl}`);
  };

  return (
    <div
      className={`p-5 bg-white border ${
        isSelected ? 'border-blue-500' : 'border-gray-200'
      } rounded-lg shadow-sm cursor-pointer transition-all hover:shadow-md`}
      onClick={handleCardClick}
    >
      <div className="flex justify-between items-start mb-3">
        <div className="flex-1">
          <p className="text-xs text-gray-500 mb-1">Name:</p>
          <h3 className="text-lg font-medium truncate">{camera.name}</h3>
        </div>
        <div className="flex space-x-1 ml-2">
          <IconButton size="small" onClick={handleEdit}>
            <EditIcon fontSize="small" style={{ color: '#757575' }} />
          </IconButton>
          <IconButton size="small" onClick={handleDelete}>
            <DeleteIcon fontSize="small" style={{ color: '#757575' }} />
          </IconButton>
        </div>
      </div>

      <div className="mb-4">
        <p className="text-xs text-gray-500 mb-1.5">Status:</p>
        <div className="flex items-center space-x-3">
          <span
            className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${
              camera.active ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
            }`}
          >
            {camera.active ? 'Active' : 'Inactive'}
          </span>
          <span className="text-xs text-gray-600 bg-gray-50 px-2.5 py-1 rounded-full">Skip Frames: {camera.skipFrames}</span>
        </div>
      </div>

      <div>
        <p className="text-xs text-gray-500 mb-1.5">Zones:</p>
        <div className="flex flex-wrap gap-1.5">
          {camera.zones.map((zone, index) => (
            <span key={index} className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
              {zone}
            </span>
          ))}
        </div>
      </div>

      <Dialog open={showDeleteConfirm} onClose={cancelDelete}>
        <DialogTitle>Delete Camera</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete camera {camera.name}? This action cannot be undone.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit dialog */}
      <Dialog open={isEditing} onClose={() => setIsEditing(false)}>
        <DialogTitle>Edit Camera</DialogTitle>
        <DialogContent>
          <DialogContentText>Camera edit form would go here.</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsEditing(false)}>Cancel</Button>
          <Button onClick={() => setIsEditing(false)} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

const RightBar = () => {
  const dispatch = useDispatch();
  const [cameras, setCameras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const cameraAdded = useSelector((state) => state.cameraReducer.cameraAdded);
  const error = null;
  // const [error, setError] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const handleNotificationClick = (event) => setAnchorEl(event.currentTarget);
  const handleNotificationClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  const dummyCameras = [
    {
      _id: '1',
      name: 'Entrance',
      active: true,
      skipFrames: 6,
      zones: ['Entry Zone'],
      videoUrl: 'https://drive.google.com/file/d/1ZyMkwNbOBvAjobOcQZjDgavSTPtjlX1v/view?usp=sharing'
    },
    {
      _id: '2',
      name: 'Help Desk',
      active: true,
      skipFrames: 5,
      zones: ['Help Desk'],
      videoUrl: 'https://drive.google.com/file/d/1lMyuGjDFPJTThTdoAmMoReXvbc04RMkg/view?usp=sharing'
    },
    {
      _id: '3',
      name: 'Accessories Zone',
      active: true,
      skipFrames: 5,
      zones: ['Hallway', 'Accessories Zone'],
      videoUrl: 'https://drive.google.com/file/d/1ZtFdlGhKTv7i7yopmd1Arpu3akyazopK/view?usp=sharing'
    },
    {
      _id: '4',
      name: 'Mobile Zone',
      active: true,
      skipFrames: 5,
      zones: ['Mobile Zone'],
      videoUrl: 'https://drive.google.com/file/d/1chJqq5HufZWejPbsA4HFeDXewsXU-tfv/view?usp=sharing'
    }
  ];

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setCameras(dummyCameras);
      setLoading(false);
    }, 500);

    if (cameraAdded) {
      dispatch({ type: 'RESET_CAMERA_ADDED' });
    }
  }, [cameraAdded, dispatch]);

  return (
    <>
      <div className="relative lg:mt-0-mt-[200%]">
        <IconButton className="absolute top-2 right-2 z-50 md:hidden" onClick={() => setIsDrawerOpen(true)}>
          <ArrowForwardIcon fontSize="small" style={{ color: 'black' }} />
        </IconButton>
      </div>

      <Drawer anchor="right" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} className="md:hidden">
        {' '}
        <div className="w-80 p-4 bg-slate-100 border border-gray-300 h-full overflow-y-auto rounded-lg">
          <IconButton onClick={() => setIsDrawerOpen(false)}>
            <CloseOutlined fontSize="small" style={{ color: 'black' }} />
          </IconButton>
          <div className="p-4 ">
            <div className="flex justify-between items-center mb-4">
              <Typography variant="h5" className="font-medium">
                Cameras
              </Typography>

              <div className="flex items-center gap-1">
                <button
                  onClick={handleNotificationClick}
                  className="flex items-center justify-center bg-[#2196f3] hover:bg-[#0e63a8] active:bg-[#0e63a8] text-white font-semibold rounded-full w-8 h-8 transition-all duration-300 ease-in-out shadow-md hover:shadow-lg relative"
                >
                  <CircleNotificationsRoundedIcon className="text-2xl" />
                </button>

                <Popover
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleNotificationClose}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                  <div className="p-4 w-64">
                    <Typography variant="h6">Notifications</Typography>
                    <Typography variant="body2" color="textSecondary">
                      No new notifications
                    </Typography>
                  </div>
                </Popover>

                <AddCameraButton />
              </div>
            </div>
            <div className="space-y-4">
              {loading ? (
                <div className="flex justify-center items-center h-full">
                  <CircularProgress />
                </div>
              ) : error ? (
                <div className="flex justify-center items-center h-full">
                  <Typography variant="body1" color="error">
                    {error}
                  </Typography>
                </div>
              ) : cameras.length === 0 ? (
                <div className="flex justify-center items-center h-full">
                  <Typography variant="body1" color="textSecondary">
                    No cameras found
                  </Typography>
                </div>
              ) : (
                cameras
                  .slice()
                  .sort((a, b) => (b.active === a.active ? 0 : b.active ? 1 : -1))
                  .map((camera) => <CameraCard key={camera._id} camera={camera} />)
              )}
            </div>
          </div>
        </div>
      </Drawer>

      <div className="hidden md:block bg-slate-100 border border-gray-300 h-full w-full overflow-y-auto rounded-lg">
        <div className="p-4">
          <div className="flex justify-between items-center mb-4">
            <Typography variant="h5" className="font-medium">
              Cameras
            </Typography>

            <div className="flex items-center gap-1">
              <button
                onClick={handleNotificationClick}
                className="flex items-center justify-center bg-[#2196f3] hover:bg-[#0e63a8] active:bg-[#0e63a8] text-white font-semibold rounded-full w-8 h-8 transition-all duration-300 ease-in-out shadow-md hover:shadow-lg relative"
              >
                <CircleNotificationsRoundedIcon className="text-2xl" />
              </button>

              <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleNotificationClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              >
                <div className="p-2 w-80">
                  <Typography variant="h4">Notifications</Typography>
                  <Typography variant="subtitle1" color="textSecondary">
                    No new notifications
                  </Typography>
                </div>
              </Popover>

              <AddCameraButton />
            </div>
          </div>
          <div className="space-y-4">
            {loading ? (
              <div className="flex justify-center items-center h-full">
                <CircularProgress />
              </div>
            ) : error ? (
              <div className="flex justify-center items-center h-full">
                <Typography variant="body1" color="error">
                  {error}
                </Typography>
              </div>
            ) : cameras.length === 0 ? (
              <div className="flex justify-center items-center h-full">
                <Typography variant="body1" color="textSecondary">
                  No cameras found
                </Typography>
              </div>
            ) : (
              cameras
                .slice()
                .sort((a, b) => (b.active === a.active ? 0 : b.active ? 1 : -1))
                .map((camera) => <CameraCard key={camera._id} camera={camera} />)
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RightBar;
